// extracted by mini-css-extract-plugin
module.exports = {"contents":"Vl-z","sectionHeading":"Wl-z"};